const o = {
  color: {
    text: "#405261ff"
  }
};
export {
  o as nav
};
